import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CovidComponent } from './covid.component';
import { RouterModule } from '@angular/router';

@NgModule({
  imports: [
    CommonModule, RouterModule
  ],
  declarations: [CovidComponent],
  exports: [CovidComponent]
})
export class CovidModule { }



// WEBPACK FOOTER //
// ./src/app/pages/covid/covid.module.ts